/* eslint-disable no-tabs */
import { Modal } from 'antd';
import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import moment from 'moment';
import Cookies from 'js-cookie';
import { hot } from 'react-hot-loader';

function AddToHomeScreen() {
	const [deferredPrompt, setDeferredPrompt] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const isMobile = useMediaQuery({
		query: '(max-width: 768px)'
	});

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	const homeScreen = () => {
		const modal = localStorage.getItem('InstallAppModalOpen');

		const lastShownDate = Cookies.get('lastShownDate');
		const today = moment().format('YYYY-MM-DD');

		if (!lastShownDate || !isWithinLastTwoWeeks(lastShownDate, today)) {
			setIsModalOpen(true);

			Cookies.set('lastShownDate', today, { expires: 14 });
		}
	};

	const isWithinLastTwoWeeks = (lastDate, currentDate) => {
		const lastDateObj = moment(lastDate, 'YYYY-MM-DD');
		const currentDateObj = moment(currentDate, 'YYYY-MM-DD');
		const differenceInDays = currentDateObj.diff(lastDateObj, 'days');
		return differenceInDays < 14;
	};

	useEffect(() => {
		let timer;

		const handleBeforeInstallPrompt = event => {
			event.preventDefault();

			setDeferredPrompt(event);
		};

		timer = setTimeout(() => {
			homeScreen();
		}, 5000);

		window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

		return () => {
			window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

			clearTimeout(timer);
		};
	}, []);

	const handleAddToHomeScreen = () => {
		if (deferredPrompt) {
			deferredPrompt.prompt();
		} else {
			// eslint-disable-next-line quotes
			alert("To install the app look for add to Homescreen or Install in your browser's menu");
		}
	};

	const addToTaskbar = () => {
		if (window.matchMedia('(display-mode: browser)').matches) {
			// Displaying in browser, prompt to add to taskbar
			alert('Please add this app to your taskbar by following the instructions provided by your browser.');
		} else {
			// Fallback for unsupported environments
			alert(
				'Unsupported environment. Please visit this page using a supported browser to add the app to your taskbar.'
			);
		}
	};

	const labelPopUp = () => {
		return isMobile ? 'Add LendAmi Web App to your home screen' : 'Add LendAmi Web App to your taskbar';
	};

	return (
		<Modal
			centered
			className="add-home-screen"
			onCancel={handleCancel}
			onOk={isMobile ? handleAddToHomeScreen : addToTaskbar}
			open={isModalOpen}
			title="">
			{labelPopUp()}
		</Modal>
	);
}

export default hot(module)(AddToHomeScreen);
